// components/About/About.js
import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <h2>About Us</h2>

        <p className="center-text about-intro">
          Welcome to Zyve, the future of fast fashion delivery!
        </p>

        <p className="about-main">
          Get the latest fashion trends delivered to your doorstep in just 1 hour – because waiting days for an outfit is so last season! 
          Our platform seamlessly connects local fashion sellers with trendsetters like you, ensuring a smooth and instant shopping experience. 
          Whether you're looking for a last-minute party outfit or a chic work look, Zyve makes sure you shop fast and slay faster!
        </p>

        <p className="about-quote center-text">
          "Fashion is about dressing according to what’s fashionable. Style is more about being yourself."
        </p>

        <p className="about-location center-text">
        📍 Serving fashion lovers across Hyderabad
        </p>
      </div>
    </section>
  );
}

export default About;
